<template functional>
  <span v-html="props.value.oldValue || 'campo vazio'" />
</template>

<script>
export default {
  name: 'HistoricalChangeExclusionValue',

  props: { value: { type: Object, default: () => ({}) } }
}
</script>
